import React from 'react';
import { SvgIcon } from 'src/components/common';
import './index.scss';
import { ORDER_BIZ_TYPE } from 'src/utils/staticData';

interface DrugItemType {
  goods: any;
  orderDetail?: any;
  bizType?: string;
}
const DrugItem = (props: DrugItemType) => {
  const { bizType, goods, orderDetail } = props;
  const { goodsImgUrl, goodsPrice = 0, goodsRealPrice = 0, activityId, goodsNum = '', goodsName, rx = false, couponType = '', goodsSpec = '' } = goods;

  const renderPrice = (price: number) => {
    price = Number.isNaN(+price) ? 0 : +price;
    const priceStr = price.toFixed(2);
    const [integer, point] = priceStr.split('.');
    return (
      <>
        <span className="sign">¥</span>
        <span className="integer">{integer}</span>
        <span className="point">.{point}</span>
      </>
    );
  };

  const isServicePack = bizType === ORDER_BIZ_TYPE.SERVPACK;

  return (
    <div className="drug">
      <SvgIcon className="photo" type="img" src={goodsImgUrl} />
      <div className="info-price">
        <div className="name-price">
          <div className="name">{goodsName}</div>
          {goodsSpec && (
          <p className="specification">
            {isServicePack
              ? orderDetail.orderStatus === 'init' && <span>支付金额：<span className="price">{orderDetail?.goodsFirstMonthAmt}元</span></span>
              : `规格：${goodsSpec}`}
          </p>
          )}
          {
            rx && <span className="rx">处方药</span>
          }
        </div>
        <div className="subname-sum">
          {
            couponType === 'CONVERSION' || isServicePack ? '' : <div className="p">{renderPrice(activityId ? goodsRealPrice : goodsPrice)}</div>
          }

          <div className="n">×{goodsNum}</div>
        </div>
      </div>
    </div>
  );
};
export default DrugItem;
